// extracted by mini-css-extract-plugin
export default {"circleWrapper":"ProfitChart_circleWrapper_HrgnU","profitValue":"ProfitChart_profitValue_j2sLY"};